import {createContext,useState,useEffect} from 'react'
import useHttp from '../../hooks/useHttp';

// const testStoreCashUrl = 'https://storecash-pdp-slider.firebaseio.com/data.json'; // Test URL
const prodStoreCashUrl = 'https://prod-pdp-storecash-slider-default-rtdb.firebaseio.com/data.json'; // Prod URL

const FirebaseConext = createContext()



export const FirebaseProvider = ({children}) => {

    const [storeCashData, setStoreCashData] = useState(null);
    const { firebaseerror, sendRequest, firebaseloading } = useHttp();

    
const rewardsData = data => {
    //console.log('from context:',data)
    setStoreCashData(data);
    }
    useEffect(() => {
        sendRequest({ url:prodStoreCashUrl }, rewardsData);
      }, [sendRequest,prodStoreCashUrl]);

  return <FirebaseConext.Provider value={{
    storeCashData,firebaseerror,sendRequest,firebaseloading
  }}>{children}</FirebaseConext.Provider>
  
}

export default FirebaseProvider
